import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './score.types';

export const scoreSelectors = {
  ...generateResourceSelectors<types.IScore>((state) => state.resource.score),
};
